// extracted by mini-css-extract-plugin
export var fullWidthButton = "_di-0";